import * as React from "react";
import { Link } from "../button";

export interface IFilterHeader {
  data: string[];
  value: string;
  onSelected: (item: string) => void;
  style?: any;
}
class FilterHeader extends React.Component<IFilterHeader> {
  public render() {
    const { value, data, style } = this.props;
    return (
      <div style={style}>
        {data.map((label: string, index: number) => {
          const last = index === length - 1;
          return (
            <div
              key={index}
              style={{ ...styles.div, marginRight: last ? 0 : 15 }}
            >
              <Link
                hideUnderline={!(value === label)}
                onClick={() => this.onSelected(label)}
                style={styles.linkStyle}
                shade={2}
                size={"big"}
              >
                {label}
              </Link>
            </div>
          );
        })}
      </div>
    );
  }
  private onSelected = (item: string) => {
    // console.log(item);
    this.props.onSelected(item);
  };
}

const styles = {
  div: {
    display: "inline",
  },
  linkStyle: {
    fontWeight: "bold",
    display: "inline",
  },
};

export default FilterHeader;
